<template>
  <div class="w-full max-w-lg mx-auto bg-gray-100 p-6 rounded-lg shadow-md">
    <h2 class="text-2xl font-bold mb-6 text-center">Создать нового сотрудника</h2>
    <form @submit.prevent="createAdmin" class="space-y-4">
      <div>
        <label class="block text-gray-700 font-semibold mb-1">Email</label>
        <input type="email" v-model="newAdmin.email" required class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500" placeholder="Введите email" />
      </div>
      <div>
        <label class="block text-gray-700 font-semibold mb-1">Пароль</label>
        <input type="password" v-model="newAdmin.password" required class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500" placeholder="Введите пароль" />
      </div>
      <div>
        <label class="block text-gray-700 font-semibold mb-1">Имя</label>
        <input type="text" v-model="newAdmin.full_name" required class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500" placeholder="Введите имя" />
      </div>
      <div>
        <label class="block text-gray-700 font-semibold mb-1">Фамилия</label>
        <input type="text" v-model="newAdmin.last_name" required class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500" placeholder="Введите фамилию" />
      </div>
      <div>
        <label class="block text-gray-700 font-semibold mb-1">Роль</label>
        <select v-model="newAdmin.role" @change="handleRoleChange" class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500">
          <option value="" disabled>Выберите роль</option>
          <option v-for="role in roles" :key="role.id" :value="role.name">{{ role.name }}</option>
          <option value="new">Новая роль...</option>
        </select>
        <input
          v-if="isNewRole"
          type="text"
          v-model="newAdmin.role"
          placeholder="Введите новую роль"
          required
          class="w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
        />
      </div>
      <button type="submit" class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold p-3 rounded-md transition duration-200">Создать</button>
    </form>
  </div>
</template>

<script>
import { createAdmin, getRoles} from "@/services/userService";
import {getPermissions} from "@/services/roleService";


export default {
  name: "AdminForm",
  data() {
    return {
      newAdmin: {
        email: "",
        password: "",
        full_name: "",
        last_name: "",
        role: "",
        permissions: [], // Список выбранных ID разрешений
      },
      roles: [],
      permissions: [], // Все доступные разрешения
      isNewRole: false,
      permissionTranslations: {
        view_dashboard: "Доступ к странице Дашборд",
        manage_users: "Страница Роли",
        view_reports: "Страница Заявки",
        manage_roles: "Страница Оценки",
        view_accounting: "Страница Бухгалтерии",
      },
    };
  },
  async created() {
    try {
      const rolesResponse = await getRoles();
      this.roles = rolesResponse.data.roles;

      const permissionsResponse = await getPermissions();
      this.permissions = permissionsResponse.data.permissions;
    } catch (error) {
      console.error("Ошибка при загрузке данных:", error);
    }
  },
  methods: {
    async createAdmin() {
      try {
        // Проверяем данные перед отправкой
        console.log("Отправляемые данные:", this.newAdmin);

        await createAdmin(this.newAdmin);
        alert("Администратор успешно создан");
        this.resetForm();
        this.$emit("adminCreated");
      } catch (error) {
        console.error("Ошибка при создании администратора:", error);
        alert("Не удалось создать администратора");
      }
    },
    resetForm() {
      this.newAdmin = {
        email: "",
        password: "",
        full_name: "",
        last_name: "",
        role: "",
        permissions: [], // Сброс выбранных ID разрешений
      };
      this.isNewRole = false;
    },
    handleRoleChange() {
      this.isNewRole = this.newAdmin.role === "new";
      if (this.isNewRole) {
        this.newAdmin.role = ""; // Очищаем значение для ввода новой роли
      }
    },
    translatePermission(permissionName) {
      return this.permissionTranslations[permissionName] || permissionName;
    },
  },
};
</script>
